module.exports = __webpack_public_path__ + "img/index_kyzx_zngz.ff467758.png";